import {
  ErrorResponse,
  FleetRentalData,
  FleetBookingData,
} from '../../../../@types';

export interface TripsState {
  entities: FleetRentalData[] | null;
  display: FleetRentalData[] | null;
  totalTrips: number;
  selected: FleetRentalData | null;
  bookingEntities: FleetBookingData[] | null;
  bookingDisplay: FleetBookingData[] | null;
  totalBookings: number;
  selectedBooking: FleetBookingData | null;
  error: ErrorResponse | null;
  loading: boolean;
  loadingBookings: boolean;
  finishingTrip: boolean;
  updatingTrip: boolean;
  finishTripViolations: string[];
  selectedTripInvoiceData: any;
  // Past trips (finished + cancelled) loaded for the VehicleTimeline's −3mo window.
  // Persisted with the trips slice → read instantly on reopen, refetched on open.
  timelineTrips: FleetRentalData[] | null;
}

export const initialState = {
  entities: null,
  display: null,
  totalTrips: 0,
  selected: null,
  bookingEntities: null,
  bookingDisplay: null,
  totalBookings: 0,
  selectedBooking: null,
  error: null,
  loading: false,
  loadingBookings: false,
  finishingTrip: false,
  updatingTrip: false,
  finishTripViolations: [],
  selectedTripInvoiceData: null,
  timelineTrips: null,
};
